import React from "react";
import { Outlet } from "react-router-dom";
import Tab from "./Tab/Tab";

export default function StdCouncilLog() {
  return (
    <div>
      <Tab />    {/* LNB 탭 항상 표시 */}
      <Outlet /> {/* 클릭된 페이지 렌더링 */}
    </div>
  );
}